import { userConstants } from './constants/userConstants';

const userSave = (UserInput: any) => {
	return {
		type: userConstants.UserSaveRequest,
		input: UserInput
	};
};

const userAccountUpdate = (userAccountInput: any) => {
	return {
		type: userConstants.userAccountUpdateRequest,
		input: userAccountInput
	};
};

const userGetDetail = (id: any, userName: any="") => {
	return {
		type: userConstants.UserGetDetailRequest,
		input: { id: id, userName: userName }
	};
};

const userGetByFilter = (filterInput: any) => {
	return {
		type: userConstants.UserGetByFilterRequest,
		input: filterInput
	};
};

const userRoleGetByFilter = () => {
	return {
		type: userConstants.UserRoleGetByFilterRequest
	};
};


const userDelete = (id: any) => {
	return {
		type: userConstants.UserDeleteRequest,
		input: id
	};
};

const userGetCountByYear = (year: any) => {
	return {
		type: userConstants.UserGetCountByYearRequest,
		input: year
	};
};

const userSaveAddress = (userInput: any) => {
	return {
		type: userConstants.UserSaveAddressRequest,
		input: userInput
	};
};

const userGetAddress = (userInput: any) => {
	return {
		type: userConstants.UserGetAddressRequest,
		input: userInput
	};
};

const userSaveCommunity = (UserInput: any) => {
	return {
		type: userConstants.UserSaveCommunityRequest,
		input: UserInput
	};
};

const userUpdateActiveStatus = (userId: any) => {
	return {
		type: userConstants.UserUpdateActiveStatusRequest,
		input: userId
	};
};

const userGetPaymentByFilter = (userInput: any) => {
	return {
		type: userConstants.UserGetPaymentRequest,
		input: userInput
	};
};

const userRoleSave = (userInput: any) => {
	return {
		type: userConstants.UserRoleSaveRequest,
		input: userInput
	};
}

const userRoleGet = (roleCode: any) => {
	return {
		type: userConstants.UserRoleGetRequest,
		input: roleCode
	};
};

const userShopifyGetAddress = (userInput: any) => {
	return {
		type: userConstants.userGetShopifyAddressRequest,
		input: userInput
	};
};

export const userAction = {
	userSave,
	userGetDetail,
	userGetByFilter,
	userRoleGetByFilter,
	userDelete,
	userAccountUpdate,
	userGetCountByYear,
	userSaveAddress,
	userGetAddress,
	userSaveCommunity,
	userUpdateActiveStatus,
	userGetPaymentByFilter,
	userRoleSave,
	userRoleGet,
	userShopifyGetAddress
}